import { Component, OnInit } from '@angular/core';

import { CommonModule, NgTemplateOutlet } from '@angular/common';
import { RouterLink } from '@angular/router';
import { NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle } from '@ng-bootstrap/ng-bootstrap';
import { IAuthMenu } from '../../models';
import { RequestMenu } from '../../models/messages';
import { AuthorizationService } from '../../services';
import { FeatureAccessService } from '../../../../../services/framework/featureaccess.service';

@Component({
  selector: 'app-admin-card',
  templateUrl: './admin-card.component.html',
  styleUrls: ['./admin-card.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterLink, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgTemplateOutlet, NgbDropdownItem]
})

export class AdminCardComponent implements OnInit {
  enableRoles: boolean = false;
  enableUsers: boolean = false;
  enableFeatures: boolean = false;
  enableAiHub: boolean = false;
  enableWordOfTheWeek: boolean = false;
  enableTaxonomy: boolean = false;
  enableUploadFiles: boolean = false;
  enableIdeaverseList: boolean = false;
  enableCuration: boolean = false;
  enablePageBuilder: boolean = false;
  attemptCount: number = 0;
  maxAttempts: number = 10;
  menuItems: IAuthMenu[] = [];
  hasItems: boolean = false;

  constructor(protected authService: AuthorizationService, private featureaccess: FeatureAccessService) {

  }

  ngOnInit() {
    this.refreshMenu();
    this.checkLocalStorage("currentFeatures");

  }
  checkLocalStorage(key: string) {
    const datafeature = localStorage.getItem(key);
    if (datafeature) {

      var isShowRoles = this.featureaccess.getAccessPermission('/admin/roles');
      if (isShowRoles) {
        this.enableRoles = true;
      }
      var isShowUsers = this.featureaccess.getAccessPermission('/admin/users');
      if (isShowUsers) {
        this.enableUsers = true;
      }
      var isShowFeatures = this.featureaccess.getAccessPermission('/admin/features');
      if (isShowFeatures) {
        this.enableFeatures = true;
      }
      var isShowAiHub = this.featureaccess.getAccessPermission('/Admin/AIHub');
      if (isShowAiHub) {
        this.enableAiHub = true;
      }
      var isShowTaxonomy = this.featureaccess.getAccessPermission('/salesanddeliveryhub/Taxonomy');
      if (isShowTaxonomy) {
        this.enableTaxonomy = true;
      }
      var isShowUploadFiles = this.featureaccess.getAccessPermission('/salesanddeliveryhub/UploadFiles');
      if (isShowUploadFiles) {
        this.enableUploadFiles = true;
      }
      var isShowIdeaverseList = this.featureaccess.getAccessPermission('/ideaverse/list');
      if (isShowIdeaverseList) {
        this.enableIdeaverseList = true;
      }
      var isShowWordOfTheWeek = this.featureaccess.getAccessPermission('/createwordoftheweek/curation');
      if (isShowWordOfTheWeek) {
        this.enableWordOfTheWeek = true;
      }
      var isShowCuration = this.featureaccess.getAccessPermission('/smartbank/curation');
      if (isShowCuration) {
        this.enableCuration = true;
      }
      var isShowPageBuilder = this.featureaccess.getAccessPermission('/pagebuilder/Projects');
      if (isShowPageBuilder) {
        this.enablePageBuilder = true;
      }

    } else {
      this.attemptCount++;
      if (this.attemptCount < this.maxAttempts) {
        setTimeout(() => {
          this.checkLocalStorage(key);
        }, 1000);
      } else {
      }
    }
  }

  refreshMenu(): void {
    let req: RequestMenu = new RequestMenu();
    req.hierarchyCode = "admin";

    this.authService.menuGet$(req).subscribe((data: IAuthMenu[]) => {
      this.menuItems = data;
      this.hasItems = (this.menuItems.length > 0);
    });
  }

  isItemRouteInternal(url: string): boolean {

    if (url.startsWith("http"))
      return false;
    else
      return true;
  }
}
